import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGaugeChartArc = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 290,
	height: 146,
	viewBox: "0 0 290 146",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.6328 145.734C6.61174 145.734 0.0340008 139.216 0.83454 131.235C4.16401 98.0412 18.8501 66.8356 42.6475 43.0382C69.8843 15.8014 106.825 0.500004 145.344 0.5C183.862 0.499996 220.803 15.8014 248.04 43.0381C271.837 66.8356 286.523 98.0412 289.853 131.235C290.654 139.216 284.076 145.734 276.055 145.734C268.034 145.734 261.625 139.207 260.625 131.248C257.425 105.775 245.847 81.924 227.501 63.5774C205.711 41.788 176.159 29.5469 145.344 29.5469C114.529 29.5469 84.9762 41.788 63.1868 63.5774C44.8401 81.924 33.2628 105.775 30.0624 131.248C29.0625 139.207 22.6539 145.734 14.6328 145.734Z",
		fill: "#F0EEED"
	})]
});
const ForwardRef = forwardRef(SvgGaugeChartArc);
export { ForwardRef as ReactComponent };
